(function () {
    var initializing = false, fnTest = /xyz/.test(function () { xyz; }) ? /\b_super\b/ : /.*/;
    // The base Class implementation (does nothing)
    this.Class = function () { };
    // Create a new Class that inherits from this class
    Class.extend = function (prop) {
        var _super = this.prototype;
        // Instantiate a base class (but only create the instance,
        // don't run the init constructor)
        initializing = true;
        var prototype = new this();
        initializing = false;
        // Copy the properties over onto the new prototype
        for (var name in prop) {
            // Check if we're overwriting an existing function
            prototype[name] = typeof prop[name] == "function" &&
                typeof _super[name] == "function" && fnTest.test(prop[name]) ?
                (function (name, fn) {
                    return function () {
                        var tmp = this._super;
                        // Add a new ._super() method that is the same method
                        // but on the super-class
                        this._super = _super[name];
                        // The method only need to be bound temporarily, so we
                        // remove it when we're done executing
                        var ret = fn.apply(this, arguments);
                        this._super = tmp;
                        return ret;
                    };
                })(name, prop[name]) :
                prop[name];
        }
        // The dummy class constructor
        function Class() {
            // All construction is actually done in the init method
            if (!initializing && this.init)
                this.init.apply(this, arguments);
        }
        // Populate our constructed prototype object
        Class.prototype = prototype;
        // Enforce the constructor to be what we expect
        Class.prototype.constructor = Class;
        // And make this class extendable
        Class.extend = arguments.callee;
        return Class;
    };
})();

(function ($, undefined) {

    var sm = window.sm = window.sm || {};
    var apiOptions;

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.utility === "undefined") {
        $.extend(sm.portal, { utility: {} });
    }

    // ** Main Localization Fucntion
    function getResourceValue(key, func) {
        // This is here so that we can always overrights the local version of getting resources 

        //1. Look in the Customer/Custom Location
        //2. Try and get data from the Portal Resources
        //3. Evaluate the function passed in
        //4. Return Key

        // Try Custom/Overwritten Location
        var item = key;
        if (sm.portal.utility.isNullOrEmpty(key)) {
            return "Error: Missing Resource";
        }
        try {
            if (!sm.portal.utility.isNullOrEmpty(key)) {
                item = sm.custom.resources.portalResource.getValue(key);
            }
        }
        catch (c) {
            // ERRROR OCCURED! - CUSTOM PATH  
        }

        // Keep checking, value is the same
        if (item.toLowerCase() === key.toLowerCase()) {
            try {
                if (!sm.portal.utility.isNullOrEmpty(key)) {
                    item = sm.resources.portalResource.getValue(key);
                }
            }
            catch (t) {
                // ERRROR OCCURED! - Portal Resource  
            }
        }

        // Keep checking, value is the same
        if (item.toLowerCase() === key.toLowerCase() && !sm.portal.utility.isNullOrEmpty(func)) {
            try {
                item = eval(func);
            }
            catch (x) {
                // ERRROR OCCURED! - Straight Evaluation
                item = key;
            }
        }

        return item;
    }
    function isANonZeroNumber(value) {

        if (!isNullEmptyOrNothing(value) && isNumeric(value) && value !== '0' && value > 0) {
            return true;
        }
        return false;
    }

    function formatString() {
        var i = arguments.length;
        if (i === 0)
            return;
        if (i === 1) {
            return arguments[0];
        }
        var str = arguments[0];
        while (i-- && i > 0) {
            str = str.replace(new RegExp('\\{' + (i - 1) + '\\}', 'gm'), arguments[i]);
        }

        return str;
    }

    function addBreakingSpacesToUndescores(text) {
        return text.replace(/_/g, "_&#x200b;");
    }

    function isNullOrEmpty(value) {
        if (value == null || value == undefined || value.toString() == '')
            return true;
        return false;
    }

    function get(url, handleData) {
        var url = _baseApiUri + sm.portal.utility.formatString(url);
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                "x-api-version": '1'
            },
            processData: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                handleData(data);
            }
        });
    }

    // previous function is nearly identical, but this one also checks for lack of object too
    function isNullEmptyOrNothing(value) {
        if (value == null ||
            value == undefined ||
            value.toString() == '' ||
            (Array.isArray(value) && value.length == 0) ||
            (value.constructor === Object && Object.keys(value).length === 0))
            return true;
        return false;
    }

    function formatDate(dateToFormat, showDate, showTime, showDayName, showLongDayName, utc) {
        // will return any combination of date, time or dayName(long or abbreviated)
        // TODO: Take into account of other country formats for the date

        if (dateToFormat == '' || dateToFormat == null) {
            return;
        }

        var longDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var abrvDaysNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];

        var date = new Date(dateToFormat); // date is adjusted for GMT
        // reformat to local

        var now_utc = utc == true ? new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()) : date;

        if (utc == true) {
            var month = (now_utc.getUTCMonth() + 1) > 9 ? (now_utc.getUTCMonth() + 1) : "0" + (now_utc.getUTCMonth() + 1);
            var day = (now_utc.getUTCDate()) > 9 ? (now_utc.getUTCDate()) : "0" + now_utc.getUTCDate();
            var hours = (now_utc.getHours()) > 12 ? (now_utc.getHours() - 12) : "0" + (now_utc.getHours());
            var minutes = (now_utc.getUTCMinutes()) > 9 ? (now_utc.getUTCMinutes()) : "0" + (now_utc.getUTCMinutes());
            var seconds = (now_utc.getUTCSeconds()) > 9 ? (now_utc.getUTCSeconds()) : "0" + (now_utc.getUTCSeconds());
        }
        else {
            var month = (now_utc.getMonth() + 1) > 9 ? (now_utc.getMonth() + 1) : "0" + (now_utc.getMonth() + 1);
            var day = (now_utc.getDate()) > 9 ? (now_utc.getDate()) : "0" + now_utc.getDate();
            var hours = (now_utc.getHours()) > 12 ? (now_utc.getHours() - 12) : "0" + (now_utc.getHours());
            var minutes = (now_utc.getMinutes()) > 9 ? (now_utc.getMinutes()) : "0" + (now_utc.getMinutes());
            var seconds = (now_utc.getSeconds()) > 9 ? (now_utc.getSeconds()) : "0" + (now_utc.getSeconds());
        }
        // get individual pieces, then reformat

        var ampm;
        var dayName = '';

        if (now_utc.getHours() <= 12) {
            ampm = 'AM';
        } else {
            ampm = 'PM';
        }

        var d = showDate ? month + "/" + day + "/" + now_utc.getFullYear() : '';
        var t = showTime ? hours + ":" + minutes + ' ' + ampm : '';

        if (showDayName) {
            // get day of week, determine to use long name or abbreviated name
            dayName = showLongDayName ? longDayNames[now_utc.getDay()] : abrvDaysNames[now_utc.getDay()];
        }

        // take inaccount of spacing or dash
        return getLocalizedDate(((d != '' ? d + ' ' : '') +
            (t != '' ? ' ' + t : '') +
            (dayName != '' ? (d != '' || t != '' ? (' - ' + dayName) : dayName) : '')).trim());
    }

    function todaysDate() {
        var today = new Date();
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        return moment(today).format(dateFormat);
    }


    // Converting date to localized date format
    function getLocalizedDate(date) {
        var defaultDate = 'dd/mm/yyyy';  //en-GB has dd/mm/yyyy as default date format
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase() || defaultDate.toUpperCase();
        var convertedDate = date ? moment(date).format(dateFormat) : '';
        return convertedDate;
    };

    function loadTemplates(file, target, success) {
        var uri = '';
        if (file.indexOf('.html') === -1) {
            uri = scriptParams.UploadPath + '/templates/' + file + '.html';
        }
        else {
            uri = _customerUploadPath + file;
        }

        if (!sm.portal.utility.isNullOrEmpty(file)) {
            $.get(uri, function (template) {
                $("#" + target).append(template);
                $("#BasicPersonContainer").remove();
                if (!sm.portal.utility.isNullOrEmpty(success)) {
                    success();
                }
            });
        }
    }

    function loadTemplate(file, target) {

        var uri = '';
        if (file.indexOf('.html') === -1) {
            uri = scriptParams.UploadPath + '/templates/' + file + '.html';
        }
        else {
            uri = _customerUploadPath + file;
        }

        return $.ajax({
            url: uri,
            success: function (template) {
                $("#" + target).append(template);
                $("#BasicPersonContainer").remove();
            }
        });

    }

    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function addFormValidation(form) {

        if ($(form).attr("data-validate") !== "false") {

            // add js validator events
            $.validator.unobtrusive.parse($(form));
            $.validator.addClassRules("requiredInput", {
                required: true
            });

            // force eager validation
            var settngs = $.data($(form)[0], 'validator').settings;
            settngs.onfocusout = function (element) { hideValidationSummary(); if (!$(element).hasClass('ignore')) { $(element).valid(); } };
            settngs.ignore = ':input:hidden,input[type="hidden"],.ignore,.wizard-ignore,#adv_search *';

        }
        else {
            $.removeData($(form), 'validator');
            $(form).find('input, select, textarea').each(function () {
                $(this).rules('remove');
            });
        }
    }

    function newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function replaceDataFromAjax(data) {
        if (typeof (data) != "string") {
            throw "can only parse html as strings";
        }

        var edit = jQueryObjectFromAjax(data);
        edit.replaceWith(data);
        sm.portal.public.readyPage(true);
        if (edit[0] && edit[0].form) {
            sm.portal.utility.addFormValidation(edit[0].form);
        }
        if (edit[0] && edit[0].id) {
            return edit[0].id;
        }
    }

    function getParamsRaw(that1) {
        var that = that1;
        var processOuter = false;
        if ($(that1).data("editordiv")) {
            that = $("#" + $(that1).data("editordiv"));
            processOuter = true;
        }
        var formData = undefined;
        var html5 = false;
        if (typeof (window.FormData) != "undefined") {
            formData = new FormData();
            html5 = true;
        }
        var o = {};
        var url = $(that).attr("data-save");
        var dsattr = $(that).attr("data-datasourceattr");
        if (!dsattr) {
            dsattr = "data-source";
        }
        sm.portal.utility.fillAjaxHelperWithDataSource(o, formData, that, dsattr);
        if (processOuter) {
            sm.portal.utility.fillAjaxHelperWithDataSource(o, formData, that1, dsattr);
        }
        return new trs.portal.AjaxHelper(o, formData, url);
    }

    function fillAjaxHelperWithDataSource(o, formData, that, dsattr) {
        if (typeof (dsattr) == 'undefined' || !dsattr) {
            dsattr = "data-source";
        }
        var a = $('*[' + dsattr + '="' + that[0].id + '"]').not('[data-target-source]');
        var html5 = false;
        if (typeof (window.FormData) != "undefined") {
            html5 = true;
        }

        var path = false;
        if ($(that).data('usenamebinding')) {
            path = that.data('path');
            if (typeof (path) == "string") {
                path += ".";
            }
        }

        // round up normal input
        $.each(a, function () {
            var binding;
            if (typeof (path) == "string") {
                binding = this.getAttribute('name');
                if (binding) {
                    binding = binding.replace(path, '');
                    var dbinding = this.getAttribute('data-binding');
                    if (dbinding.match(/JS$/) && !binding.match(/JS$/)) {
                        binding = binding + 'JS';
                    }
                }
                else {
                    binding = this.getAttribute('data-binding');
                }
            }
            else {
                binding = this.getAttribute('data-binding');
            }
            var this1 = $(this);
            var single = this1.data('bindingsingle');
            var filtergroup = this1.data("filtergroup");
            var filtergid = this1.data("filtergid");
            var filterid = this1.data("filterid");
            var index = this1.data("index");
            if (filtergroup) {
                var parentTOC = $(this1.parents('[data-lookupgrouping]')[0]);
                processParentTOCforDS(o, parentTOC);
                if (filterid > 0) {
                    maintainFilterItem(o, filtergroup, filterid, filtergid, index);
                }
            }
            if (o[binding] !== undefined && !single) {
                if (!o[binding].push) {
                    o[binding] = [o[binding]];
                }
                if (this.type === "checkbox") {
                    o[binding].push(this.checked.toString());
                }
                else {
                    o[binding].push(this.value || '');
                }
            } else if (this.tagName == "DIV") {
                o[binding] = this.textContent || '';
            } else if (this.type == "file") {
                if (typeof (this.files) != "undefined" && this.files.length > 0) {
                    if (html5) {
                        if (this.multiple) {
                            for (var i in this.files) {
                                formData.append(binding + '[' + i + ']', this.files[i]);
                            }
                        }
                        else {
                            formData.append(binding, this.files[0]);
                        }
                    }
                    else {
                        o[binding] = this.files[0];
                    }
                }
            }
            else {
                //o[binding] = $(this).val() || '';
                if (this.type === "checkbox") {
                    o[binding] = this.checked.toString();
                }

                else if (this.getAttribute("data-html-content") == "true" && (!this.getAttribute("data-contenteditable"))) {
                    var myCode = this1.val();
                    myCode = $('<div></div>').append(myCode).find('[contenteditable]').removeAttr('contenteditable').end().html();
                    console.log(myCode);
                    o[binding] = Base64.encode(myCode);
                }

                else if (this.getAttribute("data-html-content") == "true") {
                    var myCode = this1.val();
                    o[binding] = Base64.encode(myCode);
                }

                else if (single && o[binding] !== undefined && o[binding] != '') {
                }
                else {
                    o[binding] = this1.val() || '';
                }
            }
        });

        // round up virtual input
        $('*[' + dsattr + '="' + that[0].id + '"][data-target-source]').each(function () {
            var that = $(this);
            var target = $('[' + dsattr + '="' + that.attr('data-target-source') + '"][data-binding="' + that.attr('data-target-binding') + '"]');
            o[that.attr('data-binding')] = target.val();
        });

        // data path
        var attr = that[0].getAttribute("data-path");
        if (attr) {
            o.path = attr;
        }

        // dates
        var b = a.find(".date.hasDatepicker");
        $.each(b, function () {
            if (this.name.substring(0, 6) != "Model.") {
                o[this.name] = $(this).val() || '';
            }
        });
    }

    function isValidJson(value) {
        if (typeof (value) == "object") {
            return true;
        }
        else if (typeof (value) == "string") {
            var isJson = true;
            try {
                json = $.parseJSON(value);
            }
            catch (e) {
                isJson = false;
            }
            return isJson;
        }
        return false;
    }

    function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function isNumber(n) {
        var regex = /^\d+([\.]\d+)?$/i;
        return regex.test(n);
    }

    function parseToFloat(n) {
        var value = n.replace(/,/, '.');
        return isNumber(value) ? parseFloat(value) : 0;
    }

    function defaultComparison(a, b) {
        if (sm.portal.utility.isNumeric(a) && sm.portal.utility.isNumeric(b)) return a - b;

        a = a.toString();
        b = b.toString();

        return a == b ? 0 : (a < b ? -1 : 1);
    }

    function addTitleToElement(element, val, alwaysAdd) {

        var attr = $(element).attr('title');
        if (typeof attr === typeof undefined || attr === false) {
            var att = document.createAttribute("title");
            att.value = val;
            element.setAttributeNode(att);
        }
        else {
            // Even if it exists, replace value
            if (alwaysAdd) {
                $(element).attr("title", val);
            }
        }
    }

    function whichTransitionEvent() {
        var t;
        var el = document.createElement('fakeelement');

        var transitions = {
            "transition": "transitionend",
            "OTransition": "oTransitionEnd",
            "MozTransition": "transitionend",
            "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }

    function logFocus(el) {
        var that = $(el);
        if (!sm.portal.utility.isNullEmptyOrNothing(that)) {
            that.each(function () {
                $(this).on('focus', function () {
                    console.log("Focused Element: ", this);
                });
            });
        }
    }

    // Extracts a name from the list by ID
    function extractNameFromListById(list, id) {
        var result = '';
        for (var i = 0; i < list.length; i++) {
            if ('ID' in list[i] && list[i].ID() == id || 'Value' in list[i] && list[i].Value() == id) {
                result = list[i].Text();
                break;
            }
        }
        return result;
    }

    // Checks if the varaible is a function
    function isFunction(x) {
        return Object.prototype.toString.call(x) == '[object Function]';
    }

    function flagMobile() {
        $('body').not('[data-platform-flag]').each(function () {

            if (navigator.platform == 'Win32') {
                $('body').attr('data-platform-flag', 'pc');
            }
            else if (navigator.platform == 'MacIntel') {
                $('body').attr('data-platform-flag', 'mac');
            }
        });
    }

    // Generic funciton to shuffle our array of fake data (or anything array for that matter)
    function shuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }

    var SearchHandler = Class.extend({
        init: function (that, resultDiv, options, manual, deferBinding) {
            var _that = this;
            _that.Method = $.attr(that, "data-search-method");
            _that.Action = $.attr(that, "data-search-action");
            _that.ResultDiv = resultDiv;
            _that.Config = {};
            _that.SearchCrit = {};
            _that.deferBinding = false;
            _that.SearchOptions = options;
            _that.ReturnTo = $.attr(that, "data-search-return");

            if (deferBinding) {
                _that.deferBinding = deferBinding;
            }

            var config = _that.Config;

            config["WildCard"] = "contains";
            config["PageSize"] = 30;

            if (!manual) {
                $(that).find("[data-config]").each(function () {
                    var that = $(this);
                    var attr = that.attr("data-config");
                    config[attr] = that.val();
                });
            }

            if (!manual) {
                $(that).find("[data-search]").each(function () {
                    _that.AddControl(this);
                });
            }
        },
        copy: function (handler) {
            var _that = this;
            _that.Method = handler.Method;
            _that.Action = handler.Action;
            _that.ResultDiv = handler.ResultDiv;
            _that.Config = handler.Config;
            _that.SearchCrit = handler.SearchCrit;
            _that.deferBinding = handler.deferBinding;
            _that.SearchOptions = handler.SearchOptions;
            _that.ColumnWidths = handler.ColumnWidths;
            _that.ReturnTo = handler.ReturnTo;
        },
        Execute: function (that) {
            this.ExecuteForPopup(that, '');
        },
        ExecuteForPopup: function (that, path) {
            var convertedObject = this.ConvertToPortalObject(path)
            console.log('sm.portal.js --> Inside ExecuteForPopup');
            console.log('sm.portal.js --> Path: ' + path);
            console.log('sm.portal.js --> Converted Object: %o', convertedObject);

            sm.portal.public.performPortalAjaxCall(convertedObject, function (newData, originalData) {
                console.log('sm.portal.js --> Inside Callback function for ExecuteForPopup');

                $("#" + originalData.resultDiv).html('');
                $("#" + originalData.resultDiv).html(newData.response);
                sm.portal.ui.readyPage();
                sm.portal.public.hideSearchArea();
            });
        },
        AddControl: function (control) {
            var $control = $(control);

            var searchID = $control.attr("data-searchid");
            var searchField = $control.attr("data-search");
            var dataType = $control.attr("data-type");
            var nullable = $control.attr("data-nullable");
            var nullasnull = $control.attr("data-nullasnull");
            var searchOp = $control.attr("data-searchop");
            var id = $control[0].id;

            if (!dataType) {
                dataType = "String";
            }
            if (!nullable) {
                nullable = true;
            }
            if (!searchOp) {
                searchOp = "Wildcard";
            }

            var value = "";

            if ($control.is(":checkbox")) {
                value = control.checked.toString();
            }
            else if (dataType == "intlist") {
                value = JSON.stringify($control.val());
                if (value == "null") value = "";
            }
            else {
                value = $control.val();
            }

            var crit = {
                SearchField: searchField,
                StrValue: value,
                DataType: dataType,
                SearchOp: searchOp,
                Nullable: nullable,
                NullAsNull: nullasnull,
                clientID: id
            };

            if (searchID) {
                this.SearchCrit[searchID] = crit;
            }
            else {
                this.SearchCrit[searchField] = crit;
            }

            return this;
        },
        Add: function (searchField, type, nullable, searchOp, value) {

            var crit = {
                StrValue: value,
                DataType: type,
                SearchOp: searchOp,
                Nullable: nullable
            };

            this.SearchCrit[searchField] = crit;

            return this;
        },
        SetConfig: function (parm, value) {
            this.Config[parm] = value;

            return this;
        },
        ConfigJSON: function () {
            return JSON.stringify(this.Config);
        },
        SearchJSON: function () {
            return JSON.stringify({ Info: this.SearchCrit });
        },
        OptionsJSON: function () {
            return JSON.stringify(this.SearchOptions);
        },
        SetAction: function (action) {
            var _that = this;
            _that.Action = action;
            return this;
        },
        ConvertToPortalObject: function (path) {
            return { config: this.ConfigJSON(), criteria: this.SearchJSON(), path: path, url: this.Action, type: this.Method, resultDiv: this.ResultDiv };
        }
    });

    function SortingDirection() { }
    SortingDirection.Asc = 'asc';
    SortingDirection.Desc = 'desc';

    /** 
      * @param {String} fieldName Field Name.
      * @param {SortingDirection} direction Direction.
      */
    function Sorting(fieldName, direction) {
        this.FieldName = fieldName;
        this.Direction = direction;
    }

    function FilterOperator() {
    }
    FilterOperator.Equal = 'eq';
    FilterOperator.NotEqual = 'ne';
    FilterOperator.GreaterThan = 'gt';
    FilterOperator.GreaterThanOrEqual = 'ge';
    FilterOperator.LessThan = 'lt';
    FilterOperator.LessThanOrEqual = 'le';

    /**
     * @param {String} fieldName Filed name;
     * @param {FilterOperator} operator Filter operator
     * @param {Object} value Value
     */
    function FilterDefinition(fieldName, operator, value) {
        this.FieldName = fieldName;
        this.Operator = operator;
        this.Value = value;
    }

    function FilterGroupOperator() {
    }
    FilterGroupOperator.And = 'and';
    FilterGroupOperator.Or = 'or';

    /**
     * @param {FilterGroupOperator} operator Operator
     * @param {FilterDefinition[]} definitions Definitions
     */
    function FilterGroup(operator, definitions) {
        this.Operator = operator;
        this.Definitions = definitions;
    }

    /**
     * @param {String} baseUrl Base url
     * @param {Number=} top Top
     * @param {Number=} skip Skip
     * @param {Sorting=} sorting Sorting
     * @param {FilterGroup=} filterGroup Filter group
     */
    function ODataUrlBuilder(baseUrl, top, skip, sorting, filterGroup) {
        var self = this;

        this.BaseUrl = baseUrl;
        this.Top = top;
        this.Skip = skip;
        this.Sorting = sorting;
        this.FilterGroup = filterGroup;

        /** 
         * @returns {String} OData url 
         */
        this.Build = function () {
            var url = self.BaseUrl;

            if (url.indexOf('?') === -1) {
                url += '?';
            }

            if (self.Sorting) {
                url += '&$orderby=' + self.Sorting.FieldName + ' ' + self.Sorting.Direction;
            }

            if (self.Top) {
                url += '&$top=' + self.Top;
            }

            if (self.Skip) {
                url += '&$skip=' + self.Skip;
            }

            if (self.FilterGroup) {
                var filter = '';
                $.each(self.FilterGroup.Definitions, function (index, filterDefinition) {
                    if (filter.length > 0) {
                        filter += ' ' + self.FilterGroup.Operator + ' ';
                    }

                    filter += filterDefinition.FieldName + ' ' + filterDefinition.Operator + ' ';

                    if (typeof filterDefinition.Value == 'boolean') {
                        filter += filterDefinition.Value;
                    } else if (filterDefinition.Value.toString().match(/^\d{4}-\d{2}-\d{2}$/)) {
                        filter += "datetime'" + filterDefinition.Value + "'";
                    } else if ($.isNumeric(filterDefinition.Value)) {
                        filter += filterDefinition.Value;
                    } else {
                        filter += "'" + filterDefinition.Value + "'";
                    }
                });

                url += '&$filter=' + filter;
            }

            return url;
        };
    }

    function UpdatedDegreeAuditRecordList (degreeAuditShopList) {
        return [...degreeAuditShopList.flatMap(auditShopList => auditShopList.DaInfo)]
    }

    function getApiOptions() {
        var apiURL = _baseApiUri;
        if (!_baseApiUri) {
            apiURL = scriptParams.BaseApiUrl;
        }
        // Check for trailing / in the API URL
        if (!sm.portal.utility.isNullEmptyOrNothing(apiURL)) {
            var lastChar = apiURL.substr(apiURL.length - 1);
            if (lastChar !== '/') {
                apiURL = apiURL + '/';
            }
        }
        var url = apiURL + 'api/ApiOptions/GetApiOptions';

        var apiOptions;

        $.ajax({
            type: "GET",
            url: url,
            contentType: false,
            global: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            async: false,
            success: function (data) {
                apiOptions = data;
            }
        });

        return apiOptions;
    }

    function isAPASFeatureEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.ApasEnabled : false;
    }

    function showDisplayDropandWithdrawalDeadlines() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.DisplayDropandWithdrawalDeadlines : false;
    }

    function isPescFeatureEnabled() {

        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions.PescEnabled;
    }

    function isEUFeatureEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.EuEnabled : false;
    }

    function isUKFeatureEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.UkEnabled : false;
    }

    function isConservatoireFeatureEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.ConservatoireEnabled : false;
    }

    function isCanadaFeatureEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.CanadaEnabled : false;
    }

    // function to get Final Grade Calculation toggle from optional feature
    function isFinalGradeCalculationEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.FinalGradeCalculationEnabled : false;
    }

    function isTenantAvailable(){
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

    //     "U4smPortalStaticdataServiceURL": "https://u4smportalstaticdataservice-hyh5bbbvdkbeerg2.z01.azurefd.net/portalstaticlistdata/",
    // "EnableU4smPortalStaticdataService": true,
    // "TenantGID": "4c6397a5-870f-4ec4-a8d0-c0be285d1015",
    // "PortalStaticDataFileMapping": {
    //     "PortalApplyNowSteps": "applynow/academicsectionlistdata,applynow/accessibilityneedsectionlistdata,applynow/applicationinformationsectionlistdata,applynow/conservatoirespecialismssectionlistdata,applynow/contactsectionlistdata,applynow/demographicsectionlistdata,applynow/employmentsectionlistdata,applynow/highschoolsectionlistdata,applynow/languagessectionlistdata,applynow/personsectionlistdata,applynow/qualificationssectionlistdata"
    // }

        return apiOptions?.TenantGID;
    }

    function EnableU4smPortalStaticdataService(){
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }
        return apiOptions?.EnableU4smPortalStaticdataService;
    }
    function U4smPortalStaticdataServiceURL(){
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }
        return apiOptions?.U4smPortalStaticdataServiceURL;
    }
    function PortalStaticDataFileMapping(){
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }
        return apiOptions?.PortalStaticDataFileMapping;
    }

    function isCOAEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.CostOfAttendance : false;
    }

    function isIncomeTotalEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.IncomeTotal : false;
    }

    function isNeedEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.Need : false;
    }

    function isRemainingNeedEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.RemainingNeed : false;
    }

    function isECOAEnabled() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.EstimatedCostOfAttendance : false;
    }

    function isAllowAcceptRejectAward() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        return apiOptions ? apiOptions.AllowAcceptRejectAwardsOnPortal : false;
    }

    function StudentPortalAllAllowedFileExtensions() {
        if (!apiOptions) {
            apiOptions = getApiOptions();
        }

        var defaultExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.xlsm', '.csv', '.ppt', '.pptx', '.txt', '.gif', '.tif', '.tiff', '.bmp', '.wmv', '.mp4', '.mpg', '.mpeg', '.mp3', '.wav'];

        return apiOptions ? apiOptions.StudentPortalAllowedFileExtensions : defaultExtensions;
    }

    function allowedExtension() {

        var studentPortalAllowedFileExtensions = StudentPortalAllAllowedFileExtensions();
        return studentPortalAllowedFileExtensions.join(', ');
    }

    function isValidFileType(fileName) {
        var studentPortalAllowedFileExtensions = StudentPortalAllAllowedFileExtensions();

        var escapedExtensions = studentPortalAllowedFileExtensions.map(function (ext) {
            return ext.replace('.', '\\.');
        });

        var pattern = '(' + escapedExtensions.join('|') + ')$';
        var allowedExtensionsRegExp = new RegExp(pattern, 'i');

        if (!allowedExtensionsRegExp.exec(fileName)) {
            return false;
        }
        else {
            return true;
        }
    }

    function getNationalIdentificationRegex(successCallback) {
        var apiURL = _baseApiUri;
        if (!_baseApiUri) {
            apiURL = scriptParams.BaseApiUrl;
        }
        // Check for trailing / in the API URL
        if (!sm.portal.utility.isNullEmptyOrNothing(apiURL)) {
            var lastChar = apiURL.substr(apiURL.length - 1);
            if (lastChar !== '/') {
                apiURL = apiURL + '/';
            }
        }
        var url = apiURL + 'api/studentportal/NationalIdentificationRegex';
        $.ajax({
            type: "GET",
            url: url,
            contentType: false,
            global: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                successCallback(data);
            },
            error: function () {
                return false;
            }
        });
    }

    function getNationalIdentificationValidation() {
        var validationObj = { patternMessage: null, maxLengthParams: null, maxLengthMessage: null };

        if (isUKFeatureEnabled()) {
            validationObj.patternMessage = formatString(getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'AA999999A');
            validationObj.maxLengthParams = 9;
            validationObj.maxLengthMessage = formatString(getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '9');
        }
        else if (isEUFeatureEnabled()) {
            validationObj.patternMessage = formatString(getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '16');
            validationObj.maxLengthParams = 16;
            validationObj.maxLengthMessage = formatString(getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '16');
        }
        else if (isAPASFeatureEnabled() || isCanadaFeatureEnabled()) {
            validationObj.patternMessage = formatString(getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '#########');
            validationObj.maxLengthParams = 15;
            validationObj.maxLengthMessage = formatString(getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15');
        }
        else {
            validationObj.patternMessage = formatString(getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '###-##-####');
            validationObj.maxLengthParams = 15;
            validationObj.maxLengthMessage = formatString(getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15');
        }

        return validationObj;
    }

    function ValidateCanadaSIN(val){
        if(!val) return true;
        else if(val && val.length !== 9) return false;
        else{
            var total = 0;
            var key = [1,2,1,2,1,2,1,2,1];
            for(var i=0;i<val.length;i++){
                if(parseInt(val[i])>=0){
                    var product = parseInt(val[i])*key[i];
                    if(String(product).length >1){
                        total = total + parseInt(String(product)[0]) + parseInt(String(product)[1]);
                    }else{
                        total = total + product;
                    }
                }
                else return false;
            }
            if(total%10 === 0 && total !== 0) return true;
            else return false;
        }
    }

    function RenderTemplate(name, data) {
        var temp = jQuery("<div>");
        ko.applyBindingsToNode(temp[0], { template: { "name": name, "data": data } });
        var html = temp.html();
        temp.remove();
        return html;
    };

    function AjaxGet(url, successCallback, errorCallback, completeCallback, options, async) {
        async = typeof async === 'undefined' ? true : async;
        var defaultOptions = {
            url: url,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                "x-api-version": '1'
            },
            processData: false,
            crossDomain: true,
            async: async,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                successCallback(data);
            },
            error: function (jqXHR, exception) {
                if (errorCallback) {
                    errorCallback(jqXHR, exception);
                }
            },
            complete: function (jqXhr, textStatus) {
                if (completeCallback) {
                    completeCallback(jqXhr, textStatus);
                }
            }
        };

        var settings = $.extend(defaultOptions, options);
        $.ajax(settings);
    }

    function AjaxPost(url, data, successCallback, errorCallback, completeCallback) {
        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: data,
            contentType: 'application/json; charset=utf-8',
            headers: {
                "x-api-version": '1'
            },
            processData: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (data, textStatus, jqXhr) {
                successCallback(data, textStatus, jqXhr);
            },
            error: function (jqXhr, exception) {
                if (errorCallback) {
                    errorCallback(jqXhr, exception);
                }
            },
            complete: function (jqXhr, textStatus) {
                if (completeCallback) {
                    completeCallback(jqXhr, textStatus);
                }
            }
        });
    }

    function processApasApplications() {
        var apiURL = _baseApiUri;

        if (!_baseApiUri) {
            apiURL = scriptParams.BaseApiUrl;
        }
        // Check for trailing / in the API URL
        if (!sm.portal.utility.isNullEmptyOrNothing(apiURL)) {
            var lastChar = apiURL.substr(apiURL.length - 1);
            if (lastChar !== '/') {
                apiURL = apiURL + '/';
            }
        }

        var url = apiURL + 'api/APASStudentPortal/ProcessAPAS';
        $.ajax({
            type: "GET",
            url: url,
            contentType: false,
            global: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                return data;
            },
            error: function () {
                return false;
            }
        });
    }

    function stopApasApplications() {
        var apiURL = _baseApiUri;

        if (!_baseApiUri) {
            apiURL = scriptParams.BaseApiUrl;
        }
        // Check for trailing / in the API URL
        if (!sm.portal.utility.isNullEmptyOrNothing(apiURL)) {
            var lastChar = apiURL.substr(apiURL.length - 1);
            if (lastChar !== '/') {
                apiURL = apiURL + '/';
            }
        }

        var url = apiURL + 'api/APASStudentPortal/ProcessAPAS';
        $.ajax({
            type: "GET",
            url: url,
            contentType: false,
            global: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                return data;
            },
            error: function () {
                return false;
            }
        });
    }

    function displayU4AboutDialog() {

        $("body").on("click", "a[data-about-dialog]", function () {
            var url = _baseApiUri + sm.portal.utility.formatString('api/about/Index');

            $.blockUI();

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'text',
                headers: {
                    "x-api-version": '1'
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {

                    sm.portal.ui.lightBox("", data, "c-modal c-modal--about", null, null, null, null, true);
                    sm.portal.ui.simpleContainerToggle();
                    $.unblockUI();
                },
                error: function (e) {
                    sm.portal.public.displayError(e.responseText);
                    $.unblockUI();
                }
            });
        });


        $("body").on("click keypress", ".smModalClose", function (event) {
            if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                sm.portal.ui.removeLightbox();
            }
        });
    }

    $.extend(true, sm.portal.utility, {
        isNullOrEmpty: isNullOrEmpty,
        isNullEmptyOrNothing: isNullEmptyOrNothing,
        formatString: formatString,
        addBreakingSpacesToUndescores: addBreakingSpacesToUndescores,
        isANonZeroNumber: isANonZeroNumber,
        formatDate: formatDate,
        todaysDate: todaysDate,
        getLocalizedDate: getLocalizedDate,
        getResourceValue: getResourceValue,
        loadTemplates: loadTemplates,
        loadTemplate: loadTemplate,
        getParameterByName: getParameterByName,
        addFormValidation: addFormValidation,
        newGuid: newGuid,
        replaceDataFromAjax: replaceDataFromAjax,
        getParamsRaw: getParamsRaw,
        fillAjaxHelperWithDataSource: fillAjaxHelperWithDataSource,
        isValidJson: isValidJson,
        isEmail: isEmail,
        isNumeric: isNumeric,
        isNumber: isNumber,
        parseToFloat: parseToFloat,
        defaultComparison: defaultComparison,
        addTitleToElement: addTitleToElement,
        extractNameFromListById: extractNameFromListById,
        logFocus: logFocus,
        isFunction: isFunction,
        whichTransitionEvent: whichTransitionEvent,
        flagMobile: flagMobile,
        shuffle: shuffle,
        SearchHandler: SearchHandler,
        SortingDirection: SortingDirection,
        Sorting: Sorting,
        FilterOperator: FilterOperator,
        FilterDefinition: FilterDefinition,
        FilterGroupOperator: FilterGroupOperator,
        FilterGroup: FilterGroup,
        ODataUrlBuilder: ODataUrlBuilder,
        AjaxGet: AjaxGet,
        isAPASFeatureEnabled: isAPASFeatureEnabled,
        isPescFeatureEnabled: isPescFeatureEnabled,
        isEUFeatureEnabled: isEUFeatureEnabled,
        isUKFeatureEnabled: isUKFeatureEnabled,
        isCanadaFeatureEnabled: isCanadaFeatureEnabled,
        getNationalIdentificationRegex: getNationalIdentificationRegex,
        AjaxPost: AjaxPost,
        getNationalIdentificationValidation: getNationalIdentificationValidation,
        processApasApplications: processApasApplications,
        stopApasApplications: stopApasApplications,
        displayU4AboutDialog: displayU4AboutDialog,
        RenderTemplate: RenderTemplate,
        isConservatoireFeatureEnabled: isConservatoireFeatureEnabled,
        isValidFileType: isValidFileType,
        allowedExtension: allowedExtension,
        isFinalGradeCalculationEnabled: isFinalGradeCalculationEnabled,
        ValidateCanadaSIN: ValidateCanadaSIN,
        isCOAEnabled: isCOAEnabled,
        isIncomeTotalEnabled: isIncomeTotalEnabled,
        isNeedEnabled: isNeedEnabled,
        isRemainingNeedEnabled: isRemainingNeedEnabled,
        isECOAEnabled: isECOAEnabled,
        isAllowAcceptRejectAward: isAllowAcceptRejectAward,
        get: get,
        isTenantAvailable:isTenantAvailable,
        EnableU4smPortalStaticdataService: EnableU4smPortalStaticdataService,
        U4smPortalStaticdataServiceURL: U4smPortalStaticdataServiceURL,
        PortalStaticDataFileMapping: PortalStaticDataFileMapping,
        UpdatedDegreeAuditRecordList: UpdatedDegreeAuditRecordList,
        showDisplayDropandWithdrawalDeadlines: showDisplayDropandWithdrawalDeadlines
    });

})(jQuery);